// extracted by mini-css-extract-plugin
module.exports = {"legalText":"LegalText_legalText___7pYP","legalSuper":"LegalText_legalSuper__nE6vo","slide-in-out":"LegalText_slide-in-out__n9sB9","fade-in-out":"LegalText_fade-in-out____pmK"};